import React from 'react';
import * as tableHeader from './factory/categoriesHeader.jsx';
import TableComponent from 'component/molecules/Table/TableComponent.jsx';
import { categoriesEndpoints } from 'hooks/endpoints.js';
import { useParams } from 'react-router-dom';

const CategoriesTemp = ({ isRefetch }) => {
  const { id } = useParams();

  return (
    <>
      <TableComponent
        rowKey="chatId"
        headerData={tableHeader.headerData}
        api={{
          get: {
            url: categoriesEndpoints.getChatCategorization,
            params: { botId: id },
          },
        }}
        isRefetch={isRefetch}
      />
    </>
  );
};

export default CategoriesTemp;
